import { SectionsAggregate } from '../types/graphql';

export const isCropFilterValid = (
  sectionsAggregate: SectionsAggregate,
  cropFilter: string,
) =>
  sectionsAggregate?.cropAggregates?.some(
    ({ crop }) => crop.name === cropFilter,
  ) || false;
